import { z } from 'zod'
import { RewardCategory, RewardApprSecondCategory } from '~library/enums'
import { flightSegmentSchema } from './flight-segment'
import { usedCourtesyNameSchema } from './used-courtesy-name'

/** 禮遇安排 */
export const courtesyArrangementsListSchema = z.object({
  /** 指派禮遇套裝Id */
  suitId: z.string(),
  /** 分類選項 */
  classType: z.nativeEnum(RewardCategory),
  /** 分類次選項 */
  classSecondType: z.nativeEnum(RewardApprSecondCategory),
  /** 項目名稱[英文] */
  englishName: z.string(),
  /** 項目名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 項目名稱[繁體中文] */
  traditionalName: z.string(),
  /** 可否兌換禮遇 */
  allowExchange: z.boolean(),
  /** 已使用禮遇數量 */
  quantity: z.union([z.number(), z.null()]),
  /** 套裝分類 */
  suitClassType: z.array(z.string()),
  /** 禮遇項目安排航段資訊 */
  courtesyArrangementsFlightSegment: z.array(flightSegmentSchema)
})

export const benefitAndVoucherManagementUsedCourtesySchema =
  usedCourtesyNameSchema.merge(
    z.object({
      /** 分類選項 */
      classType: z.nativeEnum(RewardCategory),
      /** 分類次選項 */
      classSecondType: z.string(),
      /** 分類第三選項 */
      classThirdType: z.string()
    })
  )

/** 行程資訊 */
export const benefitAndVoucherManagementGetSelectCourtesyArrangementsItineraryInformationSchema =
  z.object({
    /** 訂位代號 */
    pnr: z.string(),
    /** 航空公司 */
    airline: z.string(),
    /** 班機號碼 */
    flightNumber: z.string(),
    /** 機票號碼 */
    ticketNumber: z.string(),
    /** 航段 */
    flightSegment: z.array(z.string()),
    /** 出發日期 */
    departureTime: z.string(),
    /** 抵達日期 */
    arrivalTime: z.string(),
    /** 開票日期 */
    issueTime: z.string(),
    /** 艙等 */
    rbd: z.string(),
    /** 機場變更 */
    airportChange: z.string(),
    usedCourtesy: z.array(benefitAndVoucherManagementUsedCourtesySchema)
  })

export const benefitAndVoucherManagementGetSelectCourtesyArrangementsSchema =
  z.object({
    /** 排除行程 */
    excludeItinerary: z.boolean(),
    /** 可否顯示排除行程 */
    showExcludeItinerary: z.boolean(),
    /** 是否有使用禮遇項目 */
    usedCourtesy: z.boolean(),
    /** 行程資訊 */
    itineraryInformation: z.array(
      benefitAndVoucherManagementGetSelectCourtesyArrangementsItineraryInformationSchema
    ),
    /** 禮遇安排 */
    courtesyArrangements: z.array(courtesyArrangementsListSchema)
  })

export interface BenefitAndVoucherManagementUsedCourtesy
  extends z.infer<typeof benefitAndVoucherManagementUsedCourtesySchema> {}

export interface BenefitAndVoucherManagementGetSelectCourtesyArrangements
  extends z.infer<
    typeof benefitAndVoucherManagementGetSelectCourtesyArrangementsSchema
  > {}

export interface CourtesyArrangementsList
  extends z.infer<typeof courtesyArrangementsListSchema> {}

export class BenefitAndVoucherManagementGetSelectCourtesyArrangements {
  constructor() {
    return {
      excludeItinerary: false,
      showExcludeItinerary: false,
      usedCourtesy: false,
      itineraryInformation: [],
      courtesyArrangements: []
    }
  }
}
